import React, { ReactNode } from 'react';
import { ButtonType } from 'antd/es/button/buttonHelpers';
import { BackButton, CancelButton, CardEditButton, Catcher, GoToPageButton, SaveButton } from '../';
import cx from 'classnames';
import { IGetApiType } from '../../REST';
import { IComponentName, IDivMainProps } from '../../interfaces';
import { formatDataTestAttribute } from '../../instruments/testing';
import { ITrButton } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

interface ICardInfoToolBar extends IDivMainProps {
    children?: ReactNode;
    dataTest?: string;
    goToPage?: IComponentName;
    isDanger?: boolean;
    isDisabledBack?: boolean;
    isDisabledCancel?: boolean;
    isDisabledSave?: boolean;
    isHideBack?: boolean;
    isLoading?: boolean;
    isNew?: boolean;
    isSubmitButton?: boolean;
    labelSave?: ITrButton;
    loadingTypes?: IGetApiType[];
    onCancel?: () => void;
    onCancelButtonType?: ButtonType;
    onCancelDanger?: boolean;
    onCancelIcon?: React.ReactNode;
    onSave?: () => void;
    runOnBack?: () => void;
    setEditMode?: (val?: boolean) => void;
}

export const CardInfoToolBar: React.FC<ICardInfoToolBar> = ({
    children,
    className,
    dataTest = '',
    goToPage,
    isDanger,
    isDisabledBack,
    isDisabledCancel,
    isDisabledSave,
    isHideBack,
    isLoading,
    isNew,
    isSubmitButton,
    labelSave,
    loadingTypes,
    onCancel,
    onCancelButtonType,
    onCancelDanger,
    onCancelIcon,
    onSave,
    runOnBack,
    setEditMode,
    ...props
}: ICardInfoToolBar) => {
    return (
        <Catcher>
            <div
                className={cx(className, Styles.cardToolBar)}
                {...props}
                data-test={formatDataTestAttribute(dataTest, 'CardInfoToolBar', 'Container')}
            >
                {!isHideBack ? (
                    <BackButton dataTest={dataTest} isDisable={isDisabledBack} runOnBack={runOnBack} />
                ) : null}
                {goToPage ? (
                    <GoToPageButton
                        dataTest={formatDataTestAttribute(dataTest, 'CardInfoToolBar', 'BackButtonGoList')}
                        goToPage={goToPage}
                        isDisable={isDisabledBack}
                        runOnBack={runOnBack}
                    />
                ) : null}
                {onCancel ? (
                    <CancelButton
                        danger={onCancelDanger}
                        dataTest={formatDataTestAttribute(dataTest, 'CardInfoToolBar', 'CancelButton')}
                        icon={onCancelIcon}
                        isDisable={isDisabledCancel}
                        onClick={onCancel}
                        type={onCancelButtonType}
                    />
                ) : null}

                {children}
                {setEditMode ? (
                    <CardEditButton
                        setEditMode={setEditMode}
                        loadingTypes={loadingTypes}
                        isLoading={isLoading}
                        dataTest={formatDataTestAttribute(dataTest, 'CardInfoToolBar', 'EditButton')}
                    />
                ) : null}
                {onSave || isSubmitButton ? (
                    <SaveButton
                        buttonType={isSubmitButton ? 'submit' : 'button'}
                        dataTest={formatDataTestAttribute(dataTest, 'CardInfoToolBar', 'SaveButton')}
                        isDisabled={isDisabledSave}
                        isLoading={isLoading}
                        isNew={isNew}
                        label={labelSave}
                        loadingTypes={loadingTypes}
                        onClick={onSave}
                        isDanger={isDanger}
                    />
                ) : null}
            </div>
        </Catcher>
    );
};
